/* istanbul ignore file */

import dynamic from 'next/dynamic';

import { MasonryCarouselBlockProps } from 'src/components/blocks/MasonryCarouselBlock/MasonryCarouselBlock';
import { ContentBlockRenderer } from 'src/types/Block';
import { Transformer } from 'src/types/Transformer';
import { links } from './data';
import { FakeMasonryCarouselSectionContent } from './types';

/* istanbul ignore next */
export const renderer: ContentBlockRenderer<MasonryCarouselBlockProps> =
  dynamic<MasonryCarouselBlockProps>(() =>
    import('src/components/blocks/MasonryCarouselBlock/MasonryCarouselBlock').then(
      (mod) => mod.MasonryCarouselBlock,
    ),
  );

export const transformer: Transformer<
  FakeMasonryCarouselSectionContent,
  MasonryCarouselBlockProps
> = ({}) => ({
  uid: 'fake-uid',
  renderer,
  props: {
    title: 'Shop by department',
    trackingTitle: 'masonry carousel',
    links,
    carouselType: 'Masonry carousel',
  },
});
